import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'flatpickr/dist/themes/material_blue.css'; // or your theme
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css';
import { useNavigate, useParams } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler'
import dayjs from "dayjs";
import { loadStripe } from "@stripe/stripe-js";
import {
    Elements,
    useStripe,
    useElements,
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
} from "@stripe/react-stripe-js";
import StripePaymentModal from "./stripe-payment-modal2";


const GuestReassignBed = () => {

    const navigate = useNavigate();
    const { id } = useParams();

    // selectedBed should be an object
    const [selectedBed, setSelectedBed] = useState({});
    const [availableBeds, setAvailableBeds] = useState([]);
    const [guestBedHistory, setGuestBedHistory] = useState([]);

    const [properties, setProperties] = useState([]);
    const [floors, setFloors] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [bedTypes, setBedTypes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [filter, setFilter] = useState({
        id: "",
        property_id: "",
        floor_id: "",
        room_id: "",
        bedtype: "",
    });

    const [moveIn, setMoveIn] = useState({
        id: id,
        bed_id: "",
        desired_move_in_date: "",
        monthly_rate: "",
    });

    const [mode, setMode] = useState(1);
    const [monthlyRows, setMonthlyRows] = useState([]);
    const [monthlyDiscountModalIndex, setMonthlyDiscountModalIndex] = useState(null);
    const [monthlyDiscountValue, setMonthlyDiscountValue] = useState("");   
    const [showStripeModal, setShowStripeModal] = useState(false);
        const [stripePromise, setStripePromise] = useState(null);
    
const [stripeModalData, setStripeModalData] = useState({});


    // Load data on mount
    useEffect(() => {
        getProperties();
        getFloors();
        getRooms();
        getBedTypes();
        getAvailableBeds();
        getGuestBedHistory();
        getGuest();
    }, []);

    const getGuest = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-guest/${id}`,
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                }
            );
            const guest = response.data?.guest || {};
            setMoveIn(guest);

            // Load saved monthly rent rows or generate if not present
            const months = (guest.monthly_rents || []).map(row => ({
                // store month display and keep original month key if needed
                month: dayjs(row.month.replace(/-00$/, "-01")).format("MMM YYYY"),
                rate: row.rate,
                discount: parseFloat(row.discount || 0)
            }));

            setMonthlyRows(months);

        } catch (error) {
            globalErrorHandler(error, navigate);
        } finally {
            setLoading(false);
        }
    };

    const getProperties = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-properties`, { withCredentials: true });
            if (res.data.status) {
                setProperties(res.data.properties || []);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        }
    };

    const getFloors = async (propertyId) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-floors?property_id=${propertyId}`, { withCredentials: true });
            if (res.data.status) {
                setFloors(res.data.floors || []);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        }
    };


    const getRooms = async (floorId) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-rooms?floor_id=${floorId}`, { withCredentials: true });
            if (res.data.status) {
                setRooms(res.data.rooms || []);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        }
    };

    const getAvailableBeds = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-available-beds`, { withCredentials: true });
            if (res.data.status) {
                setAvailableBeds(res.data.beds || []);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        }
    };


    const getBedTypes = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-bedtypes`, { withCredentials: true });
            if (res.data.status) {
                setBedTypes(res.data.bedtypes || []);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        }
    };


    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilter(prev => ({ ...prev, [name]: value }));

        if (name === "property_id") {
            setFilter(prev => ({ ...prev, floor_id: "", room_id: "" }));
            setFloors([]);
            setRooms([]);
            getFloors(value);
        } else if (name === "floor_id") {
            setFilter(prev => ({ ...prev, room_id: "" }));
            setRooms([]);
            getRooms(value);
        }
    };

    const handleApplyFilters = async () => {
        try {
            const { property_id, floor_id, room_id, bedtype } = filter;

            const queryParams = new URLSearchParams();

            if (property_id) queryParams.append("property_id", property_id);
            if (floor_id) queryParams.append("floor_id", floor_id);
            if (room_id) queryParams.append("room_id", room_id);
            if (bedtype) queryParams.append("bedtype", bedtype);

            const response = await axios.get(
                `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-available-beds?${queryParams.toString()}`,
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                }
            );

            if (response.data?.status) {
                setAvailableBeds(response.data.beds); // adjust if response is wrapped
            } else {
                Swal.fire("Error", "Failed to apply filters", "error");
            }
        } catch (error) {
            globalErrorHandler(error, navigate);

        }
    };

    const handleSave = async (paymentMethodId=null) => {
        setIsDisabled(true);
console.log(monthlyRows);
        // Include proration info in payload for backend reconciliation
        const payload = {
            guest_id: id,
            bed_id: selectedBed.id,
            monthly_rents: monthlyRows.map(row => ({
                month:  row.month,             
                rate: parseFloat(selectedBed?.rate || 0),        // keep original month string if available
                discount: parseFloat(row.discount || 0),
            })),
            proration: {
                // include these so backend can mirror the exact charge/credit
                old_unused_credit: parseFloat(oldUnusedCredit.toFixed(2)),
                new_prorated_charge: parseFloat(newProratedCharge.toFixed(2)),
                net_adjustment: parseFloat(netAdjustment.toFixed(2)),
                proration_date: dayjs().format('YYYY-MM-DD'),
                old_bed_history_id: lastHistory?.id || null
            },
            paymentMethodId: paymentMethodId ,
            mode_of_payment: moveIn.mode_of_payment,

        };

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/reassign-guest-bed`,
                payload,
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                }
            );

            if (response.data?.status) {
                Swal.fire("Success", "Bed reassigned successfully", "success").then(() => {
                    navigate("/admin/guest-management/reassign-bed-guest-list");
                });             
            } else {
                Swal.fire("Error", response.data?.message || "Failed to reassign bed", "error");
            }
        }       catch (error) {                                                     
            globalErrorHandler(error, navigate);
        } finally {
            setIsDisabled(false);
        }
    };


const handleReassignClick = () => {

    // if recurring subscription → direct save
    if (moveIn.is_recurring == 1) {
        handleSave();
        return;
    }

    // if online payment and guest owes something (netAdjustment > 0)
    if (moveIn.mode_of_payment === "online" && netAdjustment > 0) {
        setStripeModalData({total_amount: netAdjustment.toFixed(2)});
        setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY)); // ✅ lazy-load Stripe

        setShowStripeModal(true);
        return;
    }

    // if offline or online with no amount due → just save
    handleSave();
};


const handleStripeSuccess = (paymentMethodId) => {
   
    setShowStripeModal(false);
    handleSave(paymentMethodId);
};


    const handleSelectUnit = async () => {
        if (!selectedBed?.id) {
            Swal.fire("Please select a bed.", "", "warning");
            return;
        }

        const months = monthlyRows?.map(row => ({
                // store month display and keep original month key if needed
                month: dayjs(row.month.replace(/-00$/, "-01")).format("MMM YYYY"),
                rate: selectedBed.rate,
                discount: parseFloat(row.discount || 0)
            }));

        setMonthlyRows(months);
        setMode(2);
    };


    const applyMonthlyDiscount = () => {
        const updated = [...monthlyRows];
        const row = updated[monthlyDiscountModalIndex];
        const discount = parseFloat(monthlyDiscountValue) || 0;

        if (discount >= parseFloat(selectedBed?.rate || 0)) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Discount',
                text: 'Discount must be less than the monthly amount.',
            });
            return;
        }

        row.discount = discount;
        setMonthlyRows(updated);
        setMonthlyDiscountModalIndex(null);
    };

    const getGuestBedHistory = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-guest-bed-history/${id}`, { withCredentials: true });
            if (res.data.status) {
                setGuestBedHistory(res.data.bed_history || []);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        }
    }


    // -------------------
    // Proration calculations (Stripe-style)
    // -------------------

    // helper: get last history record (active)
    const lastHistory = guestBedHistory && guestBedHistory.length > 0
        ? guestBedHistory[guestBedHistory.length - 1]
        : null;

    // totals from monthlyRows
    const totalBeforeDiscount = monthlyRows.reduce(
        (sum, row) => sum + (parseFloat(selectedBed?.rate || 0)),
        0
    );

    const totalDiscount = monthlyRows.reduce(
        (sum, row) => sum + (parseFloat(row.discount || 0)),
        0
    );

    const totalAfterDiscount = totalBeforeDiscount - totalDiscount;

    // Determine invoice_period and billing window
    const invoicePeriod = lastHistory?.invoice_period ? parseInt(lastHistory.invoice_period, 10) : 1;

    // default fallback totals (if monthlyRows doesn't match invoicePeriod)
    // If monthlyRows length equals invoicePeriod, prefer to compute newTotalForPeriod from monthlyRows
    let newTotalForPeriod = totalAfterDiscount;
    if (monthlyRows.length === invoicePeriod) {
        // sum of (selectedBed.rate - discount) for those months
        newTotalForPeriod = monthlyRows.reduce((s, row) => {
            return s + (parseFloat(selectedBed?.rate || 0) - (parseFloat(row.discount || 0) || 0));
        }, 0);
    } else {
        // fallback: assume selectedBed.rate is monthly, multiply by invoicePeriod and subtract collected discounts
        newTotalForPeriod = (parseFloat(selectedBed?.rate || 0) * invoicePeriod) - totalDiscount;
    }

    // --- compute old billing window and days ---
    const today = dayjs().startOf('day');

    // if lastHistory has effective_from and effective_to use them; otherwise derive using invoice_period
    const oldStart = lastHistory?.effective_from ? dayjs(lastHistory.effective_from) : null;
    let oldEnd = lastHistory?.effective_to ? dayjs(lastHistory.effective_to) : null;
    if (!oldStart && lastHistory && lastHistory.start_date) {
        // sometimes API uses different field names — preserve robust parsing
        // fallback: use start_date if present
        // (no-op here unless API differs)
    }

    if (!oldEnd && oldStart) {
        // fallback: compute end from start + invoice_period months
        oldEnd = oldStart.add(invoicePeriod, 'month');
    }

    // safe guards
    const daysTotal = (oldStart && oldEnd) ? Math.max(1, oldEnd.diff(oldStart, 'day')) : 1;
    // days remaining from today to oldEnd (if today >= oldEnd => 0)
    const daysRemaining = (oldEnd && today.isBefore(oldEnd)) ? Math.max(0, oldEnd.diff(today, 'day')) : 0;

    // Old total for the billing window: assume lastHistory.rate is the total charge for the invoice period
    const oldTotalForPeriod = lastHistory ? parseFloat(lastHistory.rate || 0) : 0;

    // old daily rate and credit (unused amount)
    const oldDailyRate = oldTotalForPeriod / daysTotal;
    const oldUnusedCredit = oldDailyRate * daysRemaining;

    // new daily rate (use newTotalForPeriod across same invoice window)
    const newDailyRate = (newTotalForPeriod) / daysTotal;
    const newProratedCharge = newDailyRate * daysRemaining;

    // net adjustment (stripe-style): new prorated charge minus old unused credit
    const netAdjustment = newProratedCharge - oldUnusedCredit;

    // also compute a human-friendly label for the net result
    const netLabel = netAdjustment > 0
        ? { text: `$${netAdjustment.toFixed(2)} (Guest owes)`, type: 'owe' }
        : netAdjustment < 0
            ? { text: `$${Math.abs(netAdjustment).toFixed(2)} (Credit to guest)`, type: 'credit' }
            : { text: `$0.00 (No adjustment)`, type: 'neutral' };

    // -------------------
    // End proration calculations
    // -------------------


    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }


    return (
        <div className="container-fluid px-4 mt-4 mb-5  " id="guest-main">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="mb-0">Reassign Bed</h3>
            </div>


            <div className="card shadow mt-4">

                <div className="card-header"><h5 className="mb-0">Already Assigned Beds</h5></div>

                <div className="card-body p-4">

                    <div className="row g-4">
                        <div className="col-lg-12">
                            <table className="table table-responsive table-bordered text-nowrap">
                                <thead className="table-success">
                                    <tr>
                                        <th>Property</th>
                                        <th>Floor</th>
                                        <th>Room</th>
                                        <th>Bed Type</th>
                                        <th>Bed #</th>
                                        <th>Rate</th>
                                        <th>Effective Period</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {guestBedHistory.length > 0 && guestBedHistory.map((b, idx) => {
      const from = b?.effective_from ? new Date(b.effective_from).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : "-";
      const to = b?.effective_to ? new Date(b.effective_to).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : "-";
      return (
        <tr key={idx}>
          <td>{b?.property_name || "-"}</td>
          <td>{b?.floor_name || "-"}</td>
          <td>{b?.room_no || "-"}</td>
          <td>{b?.bed_type || "-"}</td>
          <td>{b?.bed_no || "-"}</td>
          <td>${b?.rate ? `${b.rate}/${b.invoice_period} month(s)` : "0.00"}</td>
          <td>{`${from} to ${to}`}</td>
        </tr>
      );
    })}
                                </tbody>
                            </table>



                        </div>
                    </div>
                </div>
            </div>


            <div className="card shadow mt-4">

                <div className="card-header"><h5 className="mb-0">Reassigned Bed</h5></div>

                <div className="card-body p-4">


                    {mode === 1 ?
                        <>

                            <div className="row g-4">
                                {/* Filter by Property */}
                                <div className="col-12">
                                    <label className="form-label">Filter by Property</label>

                                    <div className="row align-items-end g-2 mb-4">
                                        <div className="col-md-3">
                                            <select className="form-select" name="property_id" value={filter.property_id} onChange={handleFilterChange}>
                                                <option value="">Select Property</option>
                                                {properties.map(p => (
                                                    <option key={p.id} value={p.id}>{p.property_name}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-md-3">
                                            <select className="form-select" name="floor_id" value={filter.floor_id} onChange={handleFilterChange}>
                                                <option value="">Select Floor</option>
                                                {floors.map(f => (
                                                    <option key={f.id} value={f.id}>{f.floor_name}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-md-3">
                                            <select className="form-select" name="room_id" value={filter.room_id} onChange={handleFilterChange}>
                                                <option value="">Select Room</option>
                                                {rooms.map(r => (
                                                    <option key={r.id} value={r.id}>{r.room_no}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-md-2">
                                            <select className="form-select" name="bedtype" value={filter.bedtype} onChange={handleFilterChange}>
                                                <option value="">Select Bed Type</option>
                                                {bedTypes.map(bt => (
                                                    <option key={bt.id} value={bt.id}>{bt.bedtype}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-md-1">
                                            <button type="button" className="btn btn-primary w-100" onClick={handleApplyFilters}>
                                                Apply
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row g-4">
                                <div className="col-lg-12">

                                    <table className="table table-bordered table-hover">
                                        <thead className="table-success">
                                            <tr>
                                                <th>Select</th>
                                                <th>Property</th>
                                                <th>Floor</th>
                                                <th>Room</th>
                                                <th>Bed Type</th>
                                                <th>Bed #</th>

                                                <th>Rate</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {availableBeds.length > 0 ? (
                                                availableBeds.map((bed) => (
                                                    <tr key={bed.id}>
                                                        <td className="text-center">
                                                            <input
                                                                type="radio"
                                                                name="bed_id"
                                                                value={bed.id}
                                                                checked={selectedBed.id == bed.id}
                                                                onChange={() => setSelectedBed(bed)}
                                                            />

                                                        </td>
                                                        <td>{bed.property_name}</td>
                                                        <td>{bed.floor_name}</td>
                                                        <td>{bed.room_no}</td>
                                                        <td>{bed.bedtypename}</td>
                                                        <td>{bed.bed_no}</td>

                                                        <td>${bed.rate}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center text-muted">
                                                        No beds found.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="d-flex flex-wrap gap-3 justify-content-center mt-4">
                                <button type="button" className="btn btn-lg btn-dark" onClick={handleSelectUnit} disabled={isDisabled}  >
                                    Reassign Bed
                                </button>
                            </div>

                        </>
                        :
                        <>

                            <div className="row g-4 my-4 ">
                                <div className="col-lg-12">

                                    <table className="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th>Bed</th>
                                                <th>Bed Type</th>
                                                <th>Month</th>
                                                <th>Rate</th>
                                                <th>Discount</th>
                                                <th>Subtotal</th>
                                            </tr>
                                            {monthlyRows.map((row, index) => (
                                                <tr key={index} >
                                                    <td>{selectedBed?.id}</td>
                                                    <td>{selectedBed?.bedtypename}</td>
                                                    <td>{row.month}</td>
                                                    <td>${parseFloat(selectedBed?.rate || 0).toFixed(2)}</td>
                                                    <td>

                                                        {!row.discount ? (
                                                            <button className="btn btn-outline-success btn-sm" onClick={() => {
                                                                setMonthlyDiscountModalIndex(index);
                                                                setMonthlyDiscountValue("");
                                                            }}>
                                                                <i className="bi bi-plus-lg me-1"></i>Add Discount
                                                            </button>
                                                        ) : (
                                                            <div className="d-flex align-items-center gap-2">
                                                                <span className="text-success fw-bold mb-0">${row.discount}</span>
                                                                <button
                                                                    className="btn btn-sm btn-outline-danger py-0 px-2"
                                                                    onClick={() => {
                                                                        const updated = [...monthlyRows];
                                                                        updated[index].discount = 0;
                                                                        setMonthlyRows(updated);
                                                                    }}
                                                                >
                                                                    <i className="bi bi-x-lg"></i>
                                                                </button>
                                                            </div>
                                                        )}


                                                    </td>
                                                    <td>${(parseFloat(selectedBed?.rate || 0) - (row.discount || 0)).toFixed(2)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>



                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-lg-6">
    
            <table className="table table-striped mb-0">
                <tbody>
                    <tr>
                        <th scope="row" style={{ width: "40%" }}>Change date</th>
                        <td>{today.format('YYYY-MM-DD')}</td>
                    </tr>

                    <tr>
                        <th scope="row">Old billing window</th>
                        <td>
                            {oldStart ? oldStart.format('YYYY-MM-DD') : '-'}
                            {"  →  "}
                            {oldEnd ? oldEnd.format('YYYY-MM-DD') : '-'}
                        </td>
                    </tr>

                    <tr>
                        <th scope="row">Days in billing window</th>
                        <td>{daysTotal}</td>
                    </tr>

                    <tr>
                        <th scope="row">Days remaining (from today)</th>
                        <td>{daysRemaining}</td>
                    </tr>

                    <tr>
                        <th scope="row">Mode of Payment</th>
                        <td>
                            {moveIn?.is_recurring==1?" Subscription":""}
{netAdjustment > 0 && moveIn.is_recurring!=1  &&

 <div className="d-flex flex-direction-row mb-3" >
                            <div className="form-check me-3" onClick={(e) => setMoveIn(prev => ({ ...prev, mode_of_payment: 'online', is_recurring: 0 }))}  >
                                <input className="form-check-input" type="radio" name="mode_of_payment" id="modeOfPaymentOnline" value="online" checked={moveIn?.mode_of_payment === "online"}  />
                                <label className=" form-check-label" htmlFor="invoiceEmail">Online</label>
                            </div>
                            <div className="form-check" onClick={(e) => setMoveIn(prev => ({ ...prev, mode_of_payment: 'offline', is_recurring: 0 }))}  >
                                <input className="form-check-input" type="radio" name="mode_of_payment" id="modeOfPaymentOffline" value="offline" checked={moveIn?.mode_of_payment === "offline"}  />
                                <label className=" form-check-label" htmlFor="invoicePrinted">Offline (Cash)</label>
                            </div>
                        </div>
}
                        </td>
                    </tr>
                </tbody>
            </table>
      
</div>


                                <div className="col-lg-6">
                                    <table className="table table-striped">
                                        <tbody>
                                            <tr>
                                                <th>Sub Total (New - gross)</th>
                                                <td>${newTotalForPeriod.toFixed(2)}</td>
                                            </tr>

                                            <tr>
                                                <th>Old Plan Total</th>
                                                <td>${oldTotalForPeriod.toFixed(2)}</td>
                                            </tr>

                                            <tr>
                                                <th>Old Unused (Credit)</th>
                                                <td>${oldUnusedCredit.toFixed(2)}</td>
                                            </tr>

                                            <tr>
                                                <th>New Prorated Charge</th>
                                                <td>${newProratedCharge.toFixed(2)}</td>
                                            </tr>

                                            <tr className={netAdjustment > 0 ? "table-warning" : netAdjustment < 0 ? "table-success" : ""}>
                                                <th>Net Adjustment</th>
                                                <td className="fw-bold">{netLabel.text}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="d-flex flex-wrap gap-3 justify-content-center mt-4">
                                <button type="button" className="btn btn-lg btn-dark" onClick={() => setMode(1)}   >Cancel</button>
                                <button type="button" className="btn btn-lg btn-dark" onClick={handleReassignClick} disabled={isDisabled}>Reassign Bed</button>

                            </div>

                        </>
                    }

                </div>
            </div>




            {monthlyDiscountModalIndex !== null && (
                <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Discount for {monthlyRows[monthlyDiscountModalIndex]?.month}</h5>
                                <button type="button" className="btn-close" onClick={() => setMonthlyDiscountModalIndex(null)}></button>
                            </div>
                            <div className="modal-body">
                                <input
                                    type="number"
                                    min={0}
                                    className="form-control"
                                    value={monthlyDiscountValue}
                                    onChange={(e) => setMonthlyDiscountValue(e.target.value)}
                                />
                                <small className="text-muted mt-1 d-block">
                                    This amount is in <strong>USD ($)</strong>.
                                </small>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setMonthlyDiscountModalIndex(null)}>Cancel</button>
                                <button className="btn btn-primary" onClick={applyMonthlyDiscount}>Apply</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


{/* ===== STRIPE PAYMENT MODAL ===== */}
{showStripeModal && stripePromise && (
    <div className="modal show d-block" tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content bg-light">
                <div className="modal-header">
                    <h5 className="modal-title">Online Payment</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowStripeModal(false)}
                    />
                </div>

              <div className="modal-body">
                                <Elements stripe={stripePromise}>
                                   
                                    <StripePaymentModal stripeModalData={stripeModalData} onSuccess={handleStripeSuccess} onCancel={() => setShowStripeModal(false)} />
                                </Elements>
                            </div>
            </div>
        </div>
    </div>
)}



        </div>
    );
};

export default GuestReassignBed;
